export enum CvType {
    WEGESTU = 'wegestu',
    ESN = 'esn'
  }  